// src/components/Layout.js
import Header from "../Navigation/Header";
import { Outlet } from "react-router-dom"; // Used to render nested routes in React Router

const Layout = () => {
  return (
    <div>
      <Header />
      <main>
        <Outlet /> {/* This is where your page content will be injected */}
      </main>
    </div>
  );
};

export default Layout;
